module.exports = __webpack_public_path__ + "img/4.f86f486a.jpg";